module.exports = __webpack_public_path__ + "img/24_12.07183448.png";